export function formatPrice(price, locale = "pt") {
  if (price == null) return locale === "es" ? "A convenir" : "A combinar";
  return locale === "es"
    ? new Intl.NumberFormat("es-PY", { style: "currency", currency: "PYG", maximumFractionDigits: 0 }).format(price)
    : new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(price);
}

export function formatDateBR(iso, locale = "pt") {
  const [y, m, d] = iso.split("-").map(Number);
  const s = new Intl.DateTimeFormat(locale === "es" ? "es-PY" : "pt-BR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
  }).format(new Date(y, m - 1, d));
  return s.charAt(0).toUpperCase() + s.slice(1);
}
